import { worker } from '../mocks/browser'

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()
  if (runtimeConfig.public.environment === 'local') {
    worker.start()
  }
})